import * as React from "react";
import { BrandPromotion } from "./BrandPromotion.js";
import { useCmsData } from "../../../../context/context/CmsContext.js";
import { useProductData } from "../../../../context/context/product-context-hooks.js";
const BrandPromotionContainer = ({ className, isClickable, size }) => {
  const { brandPromotions } = useCmsData();
  const {
    product: { brandName }
  } = useProductData();
  return /* @__PURE__ */ React.createElement(
    BrandPromotion,
    {
      brandPromotions,
      brandName,
      className,
      isClickable,
      size
    }
  );
};
export {
  BrandPromotionContainer
};
//# sourceMappingURL=BrandPromotionContainer.js.map
